import { useEffect } from 'react';
import { startSignIn, type SubscriberIdentity } from '../lib/identity';

export function SignInModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
  onSignedIn?: (identity: SubscriberIdentity) => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-surface p-6 shadow-cardHover"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold tracking-tight">Sign in with Lenny Access</h2>
        <p className="mt-2 text-sm text-ink-muted">
          Workshops and recordings are for eligible Lenny's Newsletter subscribers.
          We'll send you to Lenny Access, then bring you back here.
        </p>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-end">
          <button type="button" onClick={onClose} className="btn-secondary sm:w-auto">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => startSignIn()}
            className="btn-accent sm:min-w-[260px]"
          >
            Continue with Lenny's Newsletter
          </button>
        </div>
      </div>
    </div>
  );
}
